import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { AuthenticationService } from '@/services/AuthenticationService'

export function usePushNotificationListener() {
  const router = useRouter()

  const setupPushNotificationListener = () => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', async (event) => {
        if (event.data?.type === 'NOTIFICATION_CLICK') {
          const targetUrl = event.data.url

          try {
            await AuthenticationService.updateAccessToken()
            await router.push(targetUrl).catch((err) => {
              console.error('[Vue Router] Navigation rejected/failed:', err)
            })
          } catch (error) {
            console.warn(
              '[Vue] Session expired after push notification click. Redirecting to Login.',
              error
            )
            await router.push({ name: 'Login', query: { redirect: targetUrl } }).catch((e) => {
              console.error('[Vue Router] Redirect to Login failed:', e)
            })
          }
        }
      })
    }
  }

  onMounted(() => {
    setupPushNotificationListener()
  })
}
